"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const finelineswrinklesskin = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-finelineswrinklesskin` : '') + (description ? ` desc-finelineswrinklesskin` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-finelineswrinklesskin"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-finelineswrinklesskin"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.24 18.42a.75.75 0 0 1 .5 1.42c-.34.12-.71.2-1.1.26a8.86 8.86 0 0 1-3.6-.26.75.75 0 0 1 .5-1.42c.21.08.5.15.82.2a7.38 7.38 0 0 0 2.88-.2Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.28 17.7a.6.6 0 0 1 .85.03l.41.45a.6.6 0 0 1-.88.8l-.41-.44a.6.6 0 0 1 .03-.85Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.77 17.44a.6.6 0 0 1 .89.81l-.42.46a.6.6 0 0 1-.88-.82l.41-.45Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.63 15.9a.6.6 0 0 1 .85.03l.83.9a.6.6 0 0 1-.89.8l-.82-.9a.6.6 0 0 1 .03-.84Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.06 15.93a.75.75 0 0 1 .68 1.34h-.01l-.03.02a3.51 3.51 0 0 1-1.17.31 2.54 2.54 0 0 1-1.1-.28 3.32 3.32 0 0 1-.08-.03l-.03-.01v-.01a.75.75 0 0 1 .6-1.37l.08.03a1.54 1.54 0 0 0 .2.1c.15.05.27.07.33.07a1 1 0 0 0 .32-.08l.16-.06.04-.03h.01Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.42 15.64a.6.6 0 0 1 .89.82l-.83.9a.6.6 0 0 1-.88-.82l.82-.9Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.5 14.09a.6.6 0 0 1 .58 1.04l-.38.22a.6.6 0 0 1-.48.04.6.6 0 0 1-.28.38l-.39.21a.6.6 0 0 1-.58-1.05l.38-.2a.6.6 0 0 1 .48-.05.6.6 0 0 1 .29-.38l.38-.21Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.4 14.54a.6.6 0 0 1 .84.04l.42.45a.6.6 0 0 1-.89.8l-.41-.44a.6.6 0 0 1 .03-.85Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M6.39 14.1a.6.6 0 0 1 .82-.21l.37.22a.6.6 0 0 1 .28.39.6.6 0 0 1 .47.06l.38.23a.6.6 0 0 1-.62 1.02l-.37-.22a.6.6 0 0 1-.28-.4.6.6 0 0 1-.47-.05l-.38-.23a.6.6 0 0 1-.2-.82Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.66 14.3a.6.6 0 0 1 .88.8l-.41.46a.6.6 0 0 1-.88-.82l.4-.45Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.62 12.35a.75.75 0 0 1 .83 1.25l-.07.05h-.01a2.46 2.46 0 0 1-.16.1l-.42.19c-.31.13-.8.31-1.29.31a3.6 3.6 0 0 1-1.29-.31 5.84 5.84 0 0 1-.57-.28l-.01-.01h-.01a.75.75 0 0 1 .76-1.3l.03.02.08.04.31.15c.27.12.53.19.7.19.17 0 .43-.07.7-.19.13-.05.23-.1.31-.15l.09-.04.02-.01Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.62 12.35a.75.75 0 0 1 .83 1.25l-.07.05h-.01a2.46 2.46 0 0 1-.16.1l-.42.19c-.31.13-.8.31-1.29.31a3.6 3.6 0 0 1-1.29-.31 5.85 5.85 0 0 1-.57-.28l-.02-.01a.75.75 0 0 1 .76-1.3l.03.02.08.04.31.15c.27.12.53.19.7.19.17 0 .43-.07.7-.19.13-.05.23-.1.31-.15l.09-.04.02-.01Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.98 10.39a.6.6 0 0 1 .83.14l.38.52a.6.6 0 0 1-.98.7l-.37-.53a.6.6 0 0 1 .14-.83Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13.2 10.48a.6.6 0 1 1 .9.79l-.44.52a.6.6 0 0 1-.91-.78l.45-.53Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.85 8.81a.6.6 0 0 1 .84.14l.37.53a.6.6 0 0 1-.97.7l-.38-.53a.6.6 0 0 1 .14-.84Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14.54 8.9a.6.6 0 0 1 .92.8l-.45.52a.6.6 0 0 1-.92-.79l.45-.52Z",
    fill: "#232323"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85.76A7.82 7.82 0 0 1 12.6.45c.65.19 1.23.5 1.67.96a8.2 8.2 0 0 1 6.5 2.77c1.56 1.85 2.23 4.46 1.8 7.4-.35 2.51-1.03 4.99-2.74 6.85a7.73 7.73 0 0 1-1.52 2.68l-.26.29a7.8 7.8 0 0 1-8.31 1.92l-.37-.15a7.81 7.81 0 0 1-3.97-3.8 10.83 10.83 0 0 1-4.08-8.35v-.53C1.4 5.09 4.59 1.94 7.85.76Zm4.41 5.78-.28.01a6.32 6.32 0 0 0-5.87 6.32v2.87a6.34 6.34 0 0 0 6.3 6.55 6.3 6.3 0 0 0 2.47-.5l.29-.13a6.3 6.3 0 0 0 3.55-5.92v-.04l.04-2.83v-.31a6.35 6.35 0 0 0-6.32-6.03h-.18Zm-.1-4.65a6.34 6.34 0 0 0-3.8.28c-2.73 1-5.48 3.63-5.55 8.35V11a9.35 9.35 0 0 0 1.8 5.44 7.84 7.84 0 0 1 0-.72v-2.84a7.85 7.85 0 0 1 7.54-7.83 1.6 1.6 0 0 0 1.43-1.6 1.38 1.38 0 0 0-.29-.87c-.23-.3-.6-.53-1.12-.68Zm2.88 1.04a3.11 3.11 0 0 1-.58 2.37 7.82 7.82 0 0 1 5.8 7.57v.02l-.03 2.01a16 16 0 0 0 .85-3.53c.38-2.6-.23-4.75-1.47-6.22a6.5 6.5 0 0 0-4.57-2.22Z",
    fill: "#232323"
  }));
};
var _default = exports.default = finelineswrinklesskin;